import React, { useRef, useState } from "react";
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {
    Box,
    Button,
    Divider,
    FormGroup,
    Grid,
    IconButton,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { host } from "../../data";
import Geocode from "react-geocode";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { countries } from "../../data";
import { isValidEmail } from '../../helpers/isValidEmail';
import { useTranslation } from 'react-i18next';

Geocode.setApiKey("AIzaSyDZxhyTnVftkwNDwT2dR8ygpsztsBBwrxs"); // https://www.npmjs.com/package/react-geocode

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    textInput: {
        margin: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    clickButtons: {
        marginLeft: theme.spacing(0),
    }
}));

export default function BranchCreate({ orgInfo, firstBranch }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const branch_name = useRef("");
    const [branchName, setBranchName] = useState("");
    const branch_address_line_1 = useRef("");
    const branch_contact = useRef("");
    const branch_phone = useRef("");
    const branch_email = useRef("");
    const branch_city = useRef("");
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");

    function isValidEnteredEmail(value) {
        if (value === "")
            return (true);

        if (isValidEmail(value))
            return (true);

        alert(t("youHaveEnteredAnInvalidEmail"));
        return (false);
    };

    function isValidPhoneNumber(value) {
        if (value === "")
            return (true);

        if ((/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''))) {
            return (true);
        }

        alert(t("youHaveEnteredAnInvalidPhone"));
        return (false);
    };

    const handleChangeCountry = (event) => {
        setCountry(event.target.value);
    };

    const handleChangeRegion = (event) => {
        setRegion(event.target.value);
    };

    function validateForm() {
        var ret = 1;
        if (branch_name.current.value === "") {
            alert(t("nameInvalid"));
            ret = 0;
        }

        return ret;
    };

    const handleClick = async () => {
        if (isValidEnteredEmail(branch_email.current.value) && isValidPhoneNumber(branch_phone.current.value) && validateForm()) {
            try {
                let user = await Auth.currentAuthenticatedUser();
                user.getSession((err, session) => {
                    if (err) {
                        console.log(err);
                        return;
                    }

                    const sessionToken = session.getIdToken().jwtToken;

                    try {
                        // Get latitude & longitude from address
                        var address = branch_address_line_1.current.value + ' ' + branch_city.current.value + ' ' + region + ' ' + country;
                        if (branch_address_line_1.current.value !== "") {
                            Geocode.fromAddress(address).then(
                                (response) => {
                                    const { lat, lng } = response.results[0].geometry.location;

                                    var body = JSON.stringify(
                                        {
                                            "Name": branch_name.current.value,
                                            "Address": branch_address_line_1.current.value,
                                            "Phone": branch_phone.current.value,
                                            "ContactName": branch_contact.current.value,
                                            "Email": branch_email.current.value,
                                            "Latitude": lat,
                                            "Longitude": lng,
                                            "Country": country,
                                            "City": branch_city.current.value,
                                            "State": region,
                                            "ParentId": orgInfo.orgId,
                                            "User": user.attributes.email
                                        }
                                    );

                                    var requestOptions = {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': sessionToken
                                        },
                                        body: body
                                    };

                                    fetch(host + '/orgs/' + orgInfo.orgId + '/branches', requestOptions)
                                        .then(async response => {
                                            return { body: await response.json(), status: response.status }
                                        })
                                        .then(data => {
                                            if (data.status === 200) {
                                                let url = '/orgs/' + orgInfo.orgName + '/branches/' + branch_name.current.value;
                                                history.push(url);
                                            }
                                            else {
                                                alert(data.body);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                },
                                (error) => {
                                    console.log(error);
                                }
                            );
                        } else {
                            var body = JSON.stringify(
                                {
                                    "Name": branch_name.current.value,
                                    "Address": "",
                                    "Phone": branch_phone.current.value,
                                    "ContactName": branch_contact.current.value,
                                    "Email": branch_email.current.value,
                                    "Latitude": 0,
                                    "Longitude": 0,
                                    "Country": country,
                                    "City": branch_city.current.value,
                                    "State": region,
                                    "ParentId": orgInfo.orgId,
                                    "User": user.attributes.email
                                }
                            );

                            var requestOptions = {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': sessionToken
                                },
                                body: body
                            };

                            fetch(host + '/orgs/' + orgInfo.orgId + '/branches', requestOptions)
                                .then(async response => {
                                    return { body: await response.json(), status: response.status }
                                })
                                .then(data => {
                                    if (data.status === 200) {
                                        let url = '/orgs/' + orgInfo.orgName + '/branches/' + branch_name.current.value;
                                        history.push(url);
                                    }
                                    else {
                                        alert(data.body);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        }
                    }
                    catch (err) {
                        console.log(err);
                    } finally {
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <Grid
            container
            alignItems='stretch'
            direction='column'
            justify='flex-start'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <Tooltip title={t("goHome")}>
                        <IconButton color='primary'
                            component={RouterLink}
                            to='/'>
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>
                    <Typography variant='h5'
                        color='textPrimary'>
                        {t("back")}
                    </Typography>
                </Toolbar>
            </Grid>
            <Grid item xs><Divider /></Grid>
            {firstBranch
                ? <Grid item xs>
                    <Box border={2} borderColor='error.main'>
                        <Typography align='center' color='error'>
                            {t("beforeYouBegin")}
                        </Typography>
                    </Box>
                </Grid>
                : null}
            <Grid item xs>
                <form>
                    <Typography>
                        {t("createBranch")}
                    </Typography>
                    <FormGroup>
                        <TextField id='branch-name'
                            required
                            inputRef={branch_name}
                            label={t("branchName")}
                            variant='filled'
                            value={branchName}
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                                if (regex.test(e.target.value)) {
                                    setBranchName(e.target.value);
                                }
                            }}
                            className={classes.textInput} />
                    </FormGroup>
                    <Typography>{t("location")}</Typography>
                    <FormGroup>
                        <TextField id='branch-address'
                            inputRef={branch_address_line_1}
                            label={t("addressLine")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-city'
                            inputRef={branch_city}
                            label={t("city")}
                            variant='filled'
                            className={classes.textInput} />
                        <FormControl className={classes.formControl}>
                            <InputLabel id="country-select-label">{t("country")}</InputLabel>
                            <Select
                                labelId="country-select-label"
                                id="country-select"
                                value={country}
                                onChange={handleChangeCountry} >
                                {countries.map((country) => (
                                    <MenuItem
                                        value={country.countryName}
                                        key={country.countryShortCode}
                                    >
                                        {t(country.translationKey)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="region-select-label">{t("stateProvinceRegion")}</InputLabel>
                            <Select
                                labelId="region-select-label"
                                id="region-select"
                                value={region}
                                onChange={handleChangeRegion}
                                disabled={!country} >
                                {country
                                    ? countries
                                        .find(({ countryName }) => countryName === country)
                                        .regions.map((region) => (
                                            <MenuItem value={region.name} key={region.shortCode}>
                                                {t(region.translationKey)}
                                            </MenuItem>
                                        )) : []}
                            </Select>
                        </FormControl>
                    </FormGroup>
                    <Typography>
                        {t("branchContact")}
                    </Typography>
                    <FormGroup>
                        <TextField id='branch-contact'
                            inputRef={branch_contact}
                            label={t("name")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-phone'
                            inputRef={branch_phone}
                            label={t("phoneNumber")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-email'
                            inputRef={branch_email}
                            label={t("email")}
                            variant='filled'
                            className={classes.textInput} />
                    </FormGroup>
                </form>
            </Grid>
            <Grid item xs>
                <Button className={classes.clickButtons} variant="contained" color='primary' onClick={handleClick}>
                    {t("save")}
                </Button>
                <Button className={classes.clickButtons} component={RouterLink} to='/'>
                    {t("cancel")}
                </Button>
            </Grid>
        </Grid>
    );
}
